import darkLockup from "@/assets/xamseen-dark.png.asset.json";
import whiteLockup from "@/assets/xamseen-white.png.asset.json";
import darkMark from "@/assets/xamseen-mark-dark.png.asset.json";
import whiteMark from "@/assets/xamseen-mark-white.png";
import { cn } from "@/lib/utils";

/** Official Xamseen lockup (X symbol + wordmark). Never redraw or restyle. */
export function XamseenLogo({
  variant = "auto",
  className,
}: {
  /** "auto" follows the active theme: dark ink on light surfaces, white ink on dark. */
  variant?: "auto" | "dark" | "white";
  className?: string;
}) {
  const base = cn("h-6 w-auto select-none", className);
  if (variant !== "auto") {
    return (
      <img
        src={variant === "white" ? whiteLockup.url : darkLockup.url}
        alt="Xamseen"
        width={1630}
        height={291}
        className={base}
        draggable={false}
      />
    );
  }
  return (
    <>
      <img
        src={darkLockup.url}
        alt="Xamseen"
        width={1630}
        height={291}
        className={cn(base, "dark:hidden")}
        draggable={false}
      />
      <img
        src={whiteLockup.url}
        alt=""
        aria-hidden="true"
        width={1630}
        height={291}
        className={cn(base, "hidden dark:block")}
        draggable={false}
      />
    </>
  );
}

/** Just the X symbol, for tight square slots. */
export function XamseenMark({ className }: { className?: string }) {
  const base = cn("h-7 w-auto select-none", className);
  return (
    <>
      <img src={darkMark.url} alt="Xamseen" width={300} height={291} className={cn(base, "dark:hidden")} draggable={false} />
      <img src={whiteMark} alt="" aria-hidden="true" width={300} height={291} className={cn(base, "hidden dark:block")} draggable={false} />
    </>
  );
}
